import React, { Ref, forwardRef } from 'react';
import { InputTextProps } from '../inputText';
import css from '../inputText/InputText.module.css';
import { MaskGenerator, MaskedInput } from 'react-hook-mask';

interface MaskedInputTextProps extends InputTextProps {
  maskGenerator: MaskGenerator;
}

const MaskedInputTextComponent: React.ForwardRefRenderFunction<
  HTMLInputElement,
  MaskedInputTextProps
> = (props: MaskedInputTextProps, ref: Ref<HTMLInputElement>) => {
  const { disabled = false } = props;
  return (
    <MaskedInput
      {...(props)}
      disabled={disabled}
      role="textbox"
      className={css.textInput}
      ref={ref}
      maskGenerator={props.maskGenerator}
    />
  );
};

const MaskedInputText = forwardRef(MaskedInputTextComponent);

export default MaskedInputText;
